import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Tooltip } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { useStoreState } from "easy-peasy";

export default function EditParameterButton({
  onEdit,
  disabled,
  authSubject,
  ...props
}) {
  const { abilities } = useStoreState((store) => store.auth);

  return (
    <Tooltip title="Düzenle">
      <Button
        type="primary"
        htmlType="reset"
        icon={<FontAwesomeIcon icon={["fas", "edit"]} />}
        disabled={
          AuthCheck(abilities, AUTH_ACTIONS.WRITE, authSubject)
            ? disabled
            : true
        }
        onClick={onEdit}
        style={{
          marginRight: 8,
        }}
      />
    </Tooltip>
  );
}
